import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Device } from "../models/Device";

/** Sets the BCP 47 locale the device displays in; `null` returns it to the default. */
export function useDeviceLocaleMutation(deviceId: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (locale: string | null) => {
            await OCGatewayClient.request('updateDeviceLocale', {
                deviceId,
                locale
            });
            return locale;
        },
        onMutate: async (locale: string | null) => {
            await queryClient.cancelQueries({ queryKey: ['getDevice', deviceId] });

            const previousDevice = queryClient.getQueryData(['getDevice', deviceId]) as Device;

            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { locale });
            });

            return { previousDevice };
        },
        onError: (error, variables, context) => {
            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { locale: context?.previousDevice?.locale ?? null });
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['getDevice', deviceId] });
        }
    });

    return mutation;
}
